<template>
  <base-modal
    :title="$t('transfer_request_error_third_party_title')"
    @close="$emit('submit', null)"
  >
    <template #content>
      <h1 class="font-weight-medium primary--text title">{{ $t('transfer_request_error_third_party') }}</h1>
      <v-card-actions class="d-flex justify-end mt-10">
        <v-btn
          class="mx-2"
          color="secondary"
          type="submit"
          elevation="0"
          @click="$emit('submit', null)"
        >
          {{ $t('btn_accept') }}
        </v-btn>
      </v-card-actions>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/commons/BaseModal'

export default {
  components: { BaseModal }
}
</script>

<style></style>
